/* Groovd Webkit currency for Shopify (7.10.2026). Same rules as the CheckoutChamp landers' currency
   script (v13.1, the CC pages run that one): the visitor's currency is decided before anything is
   drawn, and every price uses Checkout Champ's rounding and format: EUR "26,90 €", SEK/CZK whole
   numbers "299 Kr", GBP "£22.90", CAD/AUD/NZD "CA$40.90".

   Two kinds of visitor:
   1. A country Shopify Markets sells in with its own currency (GB, CA, AU, NZ, AE). Shopify prices
      these itself and the checkout charges the same amounts, so the page keeps Shopify's prices.
      When Shopify has not put the visitor in their market yet, the page reloads once with
      ?country=XX (before anything is drawn when the time zone already tells the country). On these
      pages "$44.00" becomes "CA$44.00" (only the symbol), and dollar amounts written in the copy
      ("Free shipping over $100") are converted at Shopify's rate, rounded up like Shopify rounds prices.
   2. Everyone else: Shopify shows US dollars. EUR/SEK/CZK countries see their currency with Checkout
      Champ's rate and rounding (the rate is fetched from Checkout Champ, cached for a day), as the
      live store's currency app does today. The Shopify checkout still charges US dollars for them.
   US visitors: nothing changes.

   Country: the IP country Shopify reports (/browsing_context_suggestions.json, kept in
   sessionStorage gwVisitorCountry), until it arrives Shopify's market or the phone's time zone.
   QA: ?gv_currency=EUR (SEK, CZK, GBP, CAD, AUD, NZD, USD) forces the shown currency on a US-dollar
   page. If anything fails, the page stays as Shopify rendered it. */
(function () {
  try {
    var L = window.GW_LOC || {};
    var RULES = {
      USD: { s: '$', a: 'LEFT', d: 2, r: null, c: 0 },
      CAD: { s: 'CA$', a: 'LEFT', d: 2, r: 90, c: 0 },
      AUD: { s: 'AU$', a: 'LEFT', d: 2, r: 90, c: 0 },
      NZD: { s: 'NZ$', a: 'LEFT', d: 2, r: 90, c: 0 },
      GBP: { s: '£', a: 'LEFT', d: 2, r: 90, c: 0 },
      EUR: { s: '€', a: 'RIGHT_SPACE', d: 2, r: 90, c: 1 },
      SEK: { s: 'Kr', a: 'RIGHT_SPACE', d: 0, r: 1, c: 1 },
      CZK: { s: 'Kč', a: 'RIGHT_SPACE', d: 0, r: 1, c: 1 }
    };
    /* Shopify's own prices: symbol in front, the amount as Shopify gives it */
    var NATIVE_SYM = { USD: '$', CAD: 'CA$', AUD: 'AU$', NZD: 'NZ$', GBP: '£', AED: 'Dhs. ', EUR: '€', SGD: '$' };
    var COUNTRY = { US: 'USD', CA: 'CAD', AU: 'AUD', GB: 'GBP', NZ: 'NZD', SE: 'SEK', CZ: 'CZK' };
    'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ').forEach(function (c) { COUNTRY[c] = 'EUR'; });
    var ZONES = {
      'Europe/Helsinki': 'FI', 'Europe/Mariehamn': 'FI', 'Europe/Berlin': 'DE', 'Europe/Busingen': 'DE',
      'Europe/Dublin': 'IE', 'Europe/Vienna': 'AT', 'Europe/Paris': 'FR', 'Europe/Stockholm': 'SE',
      'Europe/Prague': 'CZ', 'Europe/London': 'GB', 'Europe/Belfast': 'GB', 'Pacific/Auckland': 'NZ', 'Pacific/Chatham': 'NZ',
      'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Madrid': 'ES', 'Europe/Rome': 'IT', 'Europe/Lisbon': 'PT',
      'Europe/Athens': 'GR', 'Europe/Luxembourg': 'LU', 'Europe/Tallinn': 'EE', 'Europe/Riga': 'LV', 'Europe/Vilnius': 'LT',
      'Europe/Ljubljana': 'SI', 'Europe/Bratislava': 'SK', 'Europe/Zagreb': 'HR', 'Europe/Malta': 'MT', 'Asia/Nicosia': 'CY',
      'Asia/Dubai': 'AE',
      'America/Toronto': 'CA', 'America/Montreal': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA',
      'America/Winnipeg': 'CA', 'America/Halifax': 'CA', 'America/St_Johns': 'CA', 'America/Regina': 'CA',
      'America/Moncton': 'CA', 'America/Whitehorse': 'CA', 'America/Yellowknife': 'CA', 'America/Iqaluit': 'CA'
    };
    var US_ZONE = /^(America\/(New_York|Detroit|Chicago|Denver|Boise|Phoenix|Los_Angeles|Anchorage|Juneau|Sitka|Metlakatla|Yakutat|Nome|Adak|Menominee|Puerto_Rico)|America\/(Indiana|Kentucky|North_Dakota)\/.+|Pacific\/Honolulu|US\/.+)$/;
    /* Checkout Champ's rates on 30.9.2026; only used until the live rate has arrived once */
    var FALLBACK = { EUR: 0.881795, SEK: 9.993715, CZK: 21.542732, GBP: 0.75587, CAD: 1.41921, AUD: 1.430846, NZD: 1.773113, AED: 3.6725, SGD: 1.280726 };
    var SALT = '9fdb5330-4f25-11ef-9014-4b45d80121fd'; /* the funnel's public token, as in Checkout Champ's own script */
    var RATE_URL = 'https://pages-live-api.checkoutchamp.com/providersApi/V1/Currency/exchangerate';
    var DAY = 86400000;

    function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
    function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
    function json(s) { try { return JSON.parse(s || 'null'); } catch (e) { return null; } }
    function param(name) { var m = new RegExp('[?&]' + name + '=([^&#]*)', 'i').exec(location.search); return m ? decodeURIComponent(m[1]).toUpperCase() : ''; }
    function tzCountry() {
      try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; return ZONES[tz] || (US_ZONE.test(tz) ? 'US' : (/^Australia\//.test(tz) ? 'AU' : '')); } catch (e) { return ''; }
    }

    /* ---- rounding and format, copied from Checkout Champ's checkout (ccRoundingPrice, ccFormatCurrency) ---- */
    function roundLocal(v, R) {
      v = Number(v); if (!isFinite(v)) return 0;
      var s = v.toFixed(2), parts = s.split('.'), whole = parts[0], frac = parts[1];
      if (R.r === null || R.r === undefined) return Number(s);
      if (R.r === 1) return Number(frac) ? Number(whole) + 1 : Number(whole);
      if (Number(frac) > R.r) return Number(whole) + 1 + R.r / 100;
      return Number(whole) + R.r / 100;
    }
    function fmtLocal(v, R) {
      var n = roundLocal(v, R), str = R.d === 0 ? String(Math.round(n)) : n.toFixed(R.d);
      if (R.c) str = str.replace('.', ',');
      switch (R.a) {
        case 'RIGHT': return str + R.s;
        case 'RIGHT_SPACE': return str + '\u00a0' + R.s;
        case 'LEFT_SPACE': return R.s + '\u00a0' + str;
        default: return R.s + str;
      }
    }
    function commas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

    /* ---- Shopify's state ---- */
    var cur = String(L.cur || 'USD').toUpperCase();          /* the currency Shopify prices this page in */
    var market = String(L.country || 'US').toUpperCase();    /* Shopify's market country */
    var MARKETS = L.markets || {};                            /* {GB: 'GBP', CA: 'CAD', ...} */
    var native = cur !== 'USD';
    function shopRate() { var r = Number(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 && Shopify.currency.active === cur ? r : (FALLBACK[cur] || 1); }
    function nativeFmt(n) { return (NATIVE_SYM[cur] || '') + commas(Number(n).toFixed(2)); }
    function nativeCopy(usd, decimals) { var v = Math.ceil(usd * shopRate() - 1e-9); return (NATIVE_SYM[cur] || '') + commas(decimals ? v.toFixed(2) : String(v)); }

    /* tidy the ?country= this script added */
    try {
      if (/[?&]country=/.test(location.search) && window.URL && history.replaceState) {
        var u0 = new URL(location.href);
        if ((u0.searchParams.get('country') || '').toUpperCase() === market) { u0.searchParams['delete']('country'); history.replaceState(history.state, '', u0.toString()); }
      }
    } catch (e) {}

    /* put the visitor in their Shopify market (its currency is the checkout's currency); once a session,
       plus one correction when the time zone guessed wrong */
    function switchMarket(c, final) {
      if (L.designMode || !c || !window.URL) return false;
      var target = MARKETS[c] ? c : (MARKETS.US ? 'US' : '');
      if (!target || target === market) return false;
      if ((MARKETS[target] || 'USD') === cur) return false;
      var done = ss('gwMarketSwitch') || '';
      if (done && !(final && done.indexOf('tz:') === 0)) return false;
      ss('gwMarketSwitch', (final ? 'ip:' : 'tz:') + target);
      var u = new URL(location.href); u.searchParams.set('country', target);
      location.replace(u.toString());
      return true;
    }

    /* ---- which currency, before anything is drawn ---- */
    var forced = param('gv_currency'), country = '', source = '';
    var ipc = json(ss('gwVisitorCountry'));
    if (ipc && ipc.code) { country = String(ipc.code).toUpperCase(); source = 'ip'; }
    else if (native) { country = market; source = 'shopify'; }
    else { country = tzCountry(); source = 'timezone'; }
    if (switchMarket(country, source === 'ip')) return;

    var code = native ? cur : (RULES[forced] ? forced : (COUNTRY[country] || 'USD'));
    if (!native && !RULES[code]) code = 'USD';
    function cachedRate(c) { var o = json(ls('gv_rate_' + c)); return o && o.r > 0 && Date.now() - o.t < DAY ? o.r : 0; }
    var rate = native || code === 'USD' ? 1 : (cachedRate(code) || FALLBACK[code] || 1);

    var registry = [];
    var RE = /(^|[^A-Za-z])\$\s?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{1,2})?(\s?USD\b)?/g;
    var MONEY = '.money,[data-price-now],[data-price-was-amount],[data-price-save],[data-money]';
    /* Ireland (27.10.2026, owner: "let's use what ireland uses"): Shopify prints euro prices as "€26,95"; Irish style is "€26.95".
       On the EUR store (the IE market) every "€1.234,56" becomes "€1,234.56", including prices the cart and product scripts add later. */
    var EU_FIX = native && cur === 'EUR', RE_EU = /€(\s?)(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})(?!\d)/g;
    function fixEuro(node) {
      var v = node.nodeValue;
      if (!EU_FIX || !v || v.indexOf('€') < 0) return;
      var nv = v.replace(RE_EU, function (m, sp, whole, dec) { return '€' + sp + whole.replace(/\./g, ',') + '.' + dec; });
      if (nv !== v) node.nodeValue = nv;
    }
    function render(node) {
      var src = node.__gvUsd;
      if (!native && code === 'USD') { if (node.nodeValue !== src) node.nodeValue = src; return; }
      var p = node.parentNode, inMoney = native && p && p.closest && p.closest(MONEY);
      node.nodeValue = src.replace(RE, function (m, pre, whole, dec) {
        var n = Number(whole.replace(/,/g, '') + (dec || ''));
        if (!native) return pre + fmtLocal(n * rate, RULES[code]);
        return pre + (inMoney ? nativeFmt(n) : nativeCopy(n, !!dec));
      });
    }
    function take(node) {
      if (node.__gvUsd !== undefined) return;
      var p = node.parentNode, tag = p && p.nodeName;
      if (!p || tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') return;
      fixEuro(node);
      RE.lastIndex = 0;
      if (!RE.test(node.nodeValue)) return;
      node.__gvUsd = node.nodeValue;
      registry.push(node);
      render(node);
    }
    function walk(root) {
      if (root.nodeType === 3) { take(root); return; }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      var w = document.createTreeWalker(root, 4, null, false);
      for (var n = w.nextNode(); n; n = w.nextNode()) take(n);
    }
    function rerender() { for (var i = 0; i < registry.length; i++) { try { if (registry[i].isConnected !== false) render(registry[i]); } catch (e) {} } }

    function publish(why) {
      window.gvCurrency = { code: code, rate: rate, symbol: native ? (NATIVE_SYM[cur] || '') : RULES[code].s, source: why, country: country, shopify: native };
      var h = document.documentElement;
      h.className = h.className.replace(/\s*\bgv-cur-local\b/g, '') + (code !== 'USD' ? ' gv-cur-local' : '');
    }
    publish(source);

    /* ---- what the page scripts use (cents from Liquid are in Shopify's currency) ---- */
    window.gwFormatCents = function (cents) {
      var n = Number(cents) / 100;
      if (native) return nativeFmt(n);
      if (code === 'USD') return '$' + commas(n.toFixed(2));
      return fmtLocal(n * rate, RULES[code]);
    };
    /* a total that equals the prices shown next to it: each part converted and rounded as shown, then added */
    window.gwFormatSum = function (centsList) {
      var t = 0, i;
      if (native || code === 'USD') { for (i = 0; i < centsList.length; i++) t += Number(centsList[i]) || 0; return window.gwFormatCents(t); }
      var R = RULES[code];
      for (i = 0; i < centsList.length; i++) t += roundLocal(Number(centsList[i]) / 100 * rate, R);
      var str = R.d === 0 ? String(Math.round(t)) : (Math.round(t * 100) / 100).toFixed(R.d);
      if (R.c) str = str.replace('.', ',');
      switch (R.a) {
        case 'RIGHT': return str + R.s;
        case 'RIGHT_SPACE': return str + '\u00a0' + R.s;
        case 'LEFT_SPACE': return R.s + '\u00a0' + str;
        default: return R.s + str;
      }
    };
    window.gvMoney = function (usd) { return native ? nativeCopy(Number(usd), true) : (code === 'USD' ? '$' + commas(Number(usd).toFixed(2)) : fmtLocal(Number(usd) * rate, RULES[code])); };

    function setCurrency(newCode, newRate, why) {
      if (native || !RULES[newCode]) return;
      var changed = newCode !== code || Math.abs(newRate - rate) > 1e-9;
      code = newCode; rate = newCode === 'USD' ? 1 : newRate;
      publish(why);
      if (!changed) return;
      rerender();
      try { document.dispatchEvent(new CustomEvent('gv:currency', { detail: window.gvCurrency })); } catch (e) {}
    }
    function fetchRate(c) {
      if (native || c === 'USD' || !window.fetch) return;
      try {
        fetch(RATE_URL, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json; charset=utf-8', companyToken: SALT, funnelReferenceId: '' }, body: JSON.stringify({ currencyCode: c, baseCurrencyCode: 'USD' }) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var r = d && d.result === 'SUCCESS' && Number(d.message);
            if (!(r > 0)) return;
            ls('gv_rate_' + c, JSON.stringify({ r: r, t: Date.now() }));
            if (c === code) setCurrency(code, r, 'rate');
          })['catch'](function () {});
      } catch (e) {}
    }

    /* ---- rewrite prices as the page arrives (before it is drawn); the cart and product scripts keep adding prices ---- */
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) walk(a[j]); }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('DOMContentLoaded', function () { walk(document.body); });

    /* ---- after load: the real rate and the IP country ---- */
    if (!forced) fetchRate(code);
    function onCountry(c, why) {
      c = String(c || '').toUpperCase();
      if (!c) return;
      if (switchMarket(c, true)) return;
      country = c;
      if (window.gwLocale) window.gwLocale.setCountry(c, why);
      if (native || forced) return;
      var want = COUNTRY[c] || 'USD';
      if (!RULES[want]) want = 'USD';
      if (want !== code) { setCurrency(want, want === 'USD' ? 1 : (cachedRate(want) || FALLBACK[want] || 1), why); fetchRate(want); }
    }
    if (window.gwLocale && country && source !== 'timezone') window.gwLocale.setCountry(country, source);
    if (!(ipc && ipc.code) && window.fetch) {
      fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = d && d.detected_values && d.detected_values.country;
          if (!c || !c.handle) return;
          ss('gwVisitorCountry', JSON.stringify({ code: c.handle, name: c.name }));
          try { document.dispatchEvent(new CustomEvent('gw:country', { detail: { code: c.handle, name: c.name } })); } catch (e) {}
          onCountry(c.handle, 'ip');
        })['catch'](function () {});
    }
  } catch (e) {}
})();
